import { Link, LinkDTO } from "@src/types/global";
import { api } from "@src/utils/axios-instance";

// Gets all the links for the logged in user
export async function getAllLinks(): Promise<Link[]> {
    const res = await api.get("/links");
    return res.data.data;
}
export async function createLink(formData: LinkDTO): Promise<Link> {
    const res = await api.post("/links", { link: formData });
    return res.data.data;
}

export async function updateLink({ id, ...formData }: LinkDTO): Promise<Link> {
    if (id == null || id == "") {
        throw Error("No ID given for update");
    }
    const res = await api.put("/links/" + id, { link: formData });
    return res.data.data;
}
export async function deleteLink(id: string): Promise<void> {
    await api.delete("/links/" + id);
}
